import { ActionTypeEnum } from 'redux/ActionTypeEnum';

export const initialState = {
	loading: {
		backdrop: false,
		form: false,
		skeleton: false,
		input: false,
	},
	snackbar: {
		autoHideDuration: 3000,
		message: '',
		severity: 'info',
		open: false,
	},
	errors: {},
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case ActionTypeEnum.snackbar:
			return {
				...state,
				snackbar: {
					...state.snackbar,
					...action.payload,
				},
			};

		case ActionTypeEnum.loading: {
			const payload = action.payload;

			if (typeof payload === 'boolean') {
				return {
					...state,
					loading: {
						backdrop: payload,
						form: payload,
						skeleton: payload,
						input: payload,
					},
				};
			} else {
				return {
					...state,
					loading: { ...state.loading, ...payload },
				};
			}
		}

		case ActionTypeEnum.error: {
			return {
				...state,
				// errors: action.payload,
			};
		}
		default:
			return state;
	}
};

const getSettingsLoading = (state) => state.setting.loading;
const getSettingsSnackbar = (state) => state.setting.snackbar;
const getSettingsErrors = (state) => state.setting.errors;

export { reducer as setting, getSettingsLoading, getSettingsSnackbar, getSettingsErrors };
